import Head from 'next/head';
import { Maybe, Schema as TSchema } from '@/types/generated';
export interface ISchema extends TSchema {
  /**
   * Schema from Contentful
   *
   * @type {string}
   * @memberof ISchema
   */
  schema: Maybe<Record<string, unknown>>;
  combinedSchema?: Maybe<boolean>;
}
export default function Schema({
  schema,
  combinedSchema
}: Readonly<ISchema>) {
  if (combinedSchema || !schema) {
    return null;
  }

  // Escape characters that can terminate or alter inline script parsing.
  const safeJsonLd = JSON.stringify(schema).replaceAll('<', String.raw`\u003c`).replaceAll('>', String.raw`\u003e`).replaceAll('&', String.raw`\u0026`).replaceAll('\u2028', String.raw`\u2028`).replaceAll('\u2029', String.raw`\u2029`);
  return <Head data-sentry-element="Head" data-sentry-component="Schema" data-sentry-source-file="Schema.tsx">
			<script defer={false} type="application/ld+json">
				{safeJsonLd}
			</script>
		</Head>;
}